export const isExternalLink = (link: string) => {
  const regex = new RegExp('^(http|https)://|(mailto|tel):', 'i')
  return regex.test(link)
}

export const getButtonType = (link: string) => {
  if (link) {
    return isExternalLink(link) ? 'href' : 'to'
  }

  return null
}
